import React from 'react';
import { useLocation } from 'react-router-dom';
import './Footer.css';

// Location data configuration
const locationData = {
  pune: {
    address: '📍 Pune Office Address',
    fullAddress: 'Pune, Maharashtra, India',
    phone: '+91 9992577729',
    whatsapp: '919992577729'
  },
  noida: {
    address: '📍 Noida Office Address',
    fullAddress: 'Noida, Uttar Pradesh, India',
    phone: '+91 9992577729',
    whatsapp: '919992577729'
  },
  default: {
    address: '📍 Available Pan India',
    fullAddress: 'Available Pan India',
    phone: '+91 9992577729',
    whatsapp: '919992577729'
  }
};

const Footer = () => {
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();
  
  // Determine which location data to use
  let currentLocation;
  if (pathname.includes('/pune')) {
    currentLocation = locationData.pune;
  } else if (pathname.includes('/noida')) {
    currentLocation = locationData.noida;
  } else {
    currentLocation = locationData.default;
  }

  return (
    <footer id="contact" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/images/logo/logord.png" alt="Rahar Decors" />
            </div>
            <p className="footer-tagline">India's Premier Decoration Experts</p>
            <p className="footer-description">
              Rahar Decors offers stunning decoration services for birthdays, baby showers, anniversaries, 
              and special events across India. We make every celebration memorable with professional, hassle-free decor.
            </p>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul>
              <li><a href={`tel:${currentLocation.phone.replace(/\s/g, '')}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{display: 'inline-block', marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                {currentLocation.phone}
              </a></li>
              <li><a href={`https://wa.me/${currentLocation.whatsapp}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{display: 'inline-block', marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp
              </a></li>
              <li>{currentLocation.address}</li>
              <li>{currentLocation.fullAddress}</li>
              <li>⏰ 24/7 Available</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Rahar Decors - All Rights Reserved</p>
          <div className="social-links">
            <a href="#" aria-label="Facebook">📘</a>
            <a href="#" aria-label="Instagram">📷</a>
            <a href="#" aria-label="Twitter">🐦</a>
            <a href="#" aria-label="LinkedIn">💼</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
